import { StaticticsService } from "@/common/api.service"
import { FETCH_COURSE_STATS, FETCH_GROUP_STATS, FETCH_USER_STATS, RESET_STATE} from "./actions.type"
import { SET_COURSE_STATS, SET_GROUP_STATS, SET_USER_STATS, SET_ERROR_STATS, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        coursestats: [],
        groupstats: [],
        userstats: [],
        staterrors: null,
    }
}

let state = initialState()

const getters = {
    coursestats(state) {
        return state.coursestats
    },
    groupstats(state) {
        return state.groupstats
    },
    userstats(state) {
        return state.userstats
    },
}

const actions = {
    async [FETCH_COURSE_STATS](context, slug) {
        const { data } = await StaticticsService.getcoursestats(slug)
        context.commit(SET_COURSE_STATS, data.data)
        return data;
    },
    async [FETCH_GROUP_STATS](context, slug) {
        const { data } = await StaticticsService.getgroupstats(slug)
        context.commit(SET_GROUP_STATS, data.data)
        return data;
    },
    async [FETCH_USER_STATS](context, slug) {
        const { data } = await StaticticsService.getuserstats(slug)
        context.commit(SET_USER_STATS, data.data)
        return data;
    },
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_ERROR_STATS](state, error) {
        state.staterrors = error
    },      
    [SET_COURSE_STATS](state, data) {
        state.coursestats = data
    },
    [SET_GROUP_STATS](state, data) {
        state.groupstats = data
    },
    [SET_USER_STATS](state, data) {
        state.userstats = data
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};